import React, { useEffect, useState } from 'react';
import { getMfaStatus } from '../../../services/auth.service';
import './mfa-enrollment-prompt.css';

const MFA_LATER_PREFIX = 'xspectre:mfa-prompt:later:';

/** Clears any leftover session defer keys from older builds. */
export function clearMfaEnrollmentPromptSession() {
  try {
    const keys = [];
    for (let i = 0; i < window.sessionStorage.length; i += 1) {
      const key = window.sessionStorage.key(i);
      if (key && key.startsWith(MFA_LATER_PREFIX)) keys.push(key);
    }
    keys.forEach((key) => window.sessionStorage.removeItem(key));
  } catch (_) {
    // Private mode or storage policy.
  }
}

function isMfaEnabled(status) {
  return Boolean(
    status?.active_method ||
      (Array.isArray(status?.active_methods) && status.active_methods.length > 0) ||
      status?.can_disable
  );
}

export function useMfaEnrollmentPrompt({ identity, activePage }) {
  const [needsMfa, setNeedsMfa] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const status = await getMfaStatus();
        if (!cancelled) setNeedsMfa(!isMfaEnabled(status));
      } catch (_) {
        if (!cancelled) setNeedsMfa(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [identity, activePage]);

  // Allow Profile Settings so the user can enroll; block the rest of the app until MFA is on.
  const open = needsMfa && activePage !== 'profileSettings';

  return { open, continueToSetup: () => {} };
}

export default function MfaEnrollmentPrompt({ open, onEnable }) {
  if (!open) return null;

  return (
    <div
      className="mfa-enrollment-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="mfa-enrollment-title"
      aria-describedby="mfa-enrollment-copy"
    >
      <div className="mfa-enrollment-dialog">
        <h2 id="mfa-enrollment-title" className="mfa-enrollment-title">
          Enable multi-factor authentication
        </h2>
        <p id="mfa-enrollment-copy" className="mfa-enrollment-copy">
          Add a second step to sign-in to keep this account protected.
        </p>
        <p className="mfa-enrollment-warning" role="status">
          For security purposes, the dashboard will not work until you enable multi-factor authentication.
        </p>
        <div className="mfa-enrollment-actions">
          <button type="button" className="mfa-enrollment-btn mfa-enrollment-btn--primary" onClick={onEnable}>
            Enable MFA
          </button>
        </div>
      </div>
    </div>
  );
}
